

$body.on("click",".films-browser [data-cat]",function(e){

    e.preventDefault();
    e.stopPropagation();

    let $a=$(this);
    let $all=$(this).closest(".films-browser").find("[data-cat]");
    let $targets=$(this).closest(".films-browser").find(".liste").find("[data-cats]");

    if($a.is(".active")){
        $a.removeClass("active");
    }else{
        $all.removeClass("active");
        $a.addClass("active");
    }

    let $active=$all.filter(".active");
    let catUidToShow=$active.attr("data-cat");

    if(!$active.length){
        Site.setCurrentList(catUidToShow);
        showAll();
    }else{
        Site.setCurrentList(catUidToShow);
        show(catUidToShow)
    }


    function showAll(){
        $targets.removeClass("inactive");
    }
    function show(id){
        $targets.addClass("inactive");
        $targets.filter("[data-cats*='"+id+"']").removeClass("inactive");
        $targets.filter("[data-real='"+id+"']").removeClass("inactive");
    }

});


// WEBPACK FOOTER //
// ./project/_src/components/films-browser.js